module.exports = __webpack_public_path__ + "img/cloud.29a55910.svg";